<template>
  <v-dialog v-model="show" persistent width="500">
    <v-card>
      <v-card-title class="headline">
        {{ $t("refreshModal.sessionTitle") }}
      </v-card-title>

      <v-card-text>
        {{ $t("refreshModal.sessionMsg") }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="refresh">
          {{ $t("refresh") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  created: function() {
    this.$store.watch(
      (state) => state.refresh,
      () => {
        const refresh = this.$store.state.refresh;
        if (refresh !== false) {
          this.show = true;
          this.$store.commit("setRefresh", false);
        }
      }
    );
  },
  methods: {
    refresh() {
      window.location.reload();
    },
  },
};
</script>
